import { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import HomePage from "./pages/HomePage";
import PortfolioPage from "./pages/PortfolioPage";
import AboutPage from "./pages/AboutPage";
import AlbumPage from "./pages/AlbumPage";
import NotFoundPage from "./pages/NotFoundPage";
import Seo from "./components/Seo";

export default function App() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      document.getElementById(hash.slice(1))?.scrollIntoView();
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);
  return <>
    <Seo />
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/portfolio" element={<PortfolioPage />} />
      <Route path="/portfolio/:slug" element={<AlbumPage />} />
      <Route path="/desprenoi" element={<AboutPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  </>;
}
